module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "se-coming-soon"
  }, [_c('div', {
    staticClass: "se-coming-soon-icon"
  }, [_vm._v("⚙️")]), _vm._v(" "), _c('div', {
    staticClass: "se-coming-soon-title"
  }, [_vm._v("Behavior — coming soon")]), _vm._v(" "), _c('div', {
    staticClass: "se-coming-soon-text"
  }, [_vm._v("Conditional routing, validation rules, and processing-function config for this stage will live here.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-226f4400","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/StageBehaviorTab.vue
// module id = 8rEm
// module chunks = 1